export default __webpack_public_path__ + "static/media/curation.b4eba62e.svg";